<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
    fill="currentcolor"
  >
    <g><rect fill="none" height="24" width="24" x="0" /></g>
    <g>
      <g>
        <g>
          <path
            d="M22,9.24l-7.19-0.62L12,2L9.19,8.63L2,9.24l5.46,4.73L5.82,21L12,17.27L18.18,21l-1.63-7.03L22,9.24z M12,15.4V6.1 l1.71,4.04l4.38,0.38l-3.32,2.88l1,4.28L12,15.4z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>
